
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartIsolatedDangersFilled as ObiChartIsolatedDangersFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-isolated-dangers-filled.js';
 
 
 

 
 export const ObiChartIsolatedDangersFilled = createComponent({
   react: React,
   tagName: 'obi-chart-isolated-dangers-filled',
   elementClass: ObiChartIsolatedDangersFilledElement,
   events: {
     
   }
  });
 
 